import i18n from '@app/localization/i18n';
import { get as _get } from '@lodash';
import { getFlag } from '@src/data/flagMapping';
import LottoEvent from '@core/models/lotto/LottoEvent';
import { INode } from '@app/utils/sidebar';
import { PROMOTIONS_TITLE } from '@app/store/modules/ui/sportOffer/constants.ts';

interface SelectedItem {
    type: string;
    id: string;
}

interface NavItem {
    name: string;
    icon?: string[] | string;
    flag?: string;
}

interface StructData {
    id: number;
}

export function getSportNavItem(selectedTreeItem: SelectedItem, item: NavItem, {
    selectedTreeItems,
    sports,
    tournaments,
    categories,
}: {
    selectedTreeItems: { id: number }[],
    sports: StructData[],
    tournaments: StructData[],
    categories: StructData[],
}) {
    switch (selectedTreeItem.type) {
        case 'promotions':
            item.name = PROMOTIONS_TITLE;
            item.icon = ['icon--md', 'icon-sport--1002'];
            break;
        case 'sportId':
            item.name = _get(sports, [selectedTreeItem.id, 'name'], '');
            item.icon = ['icon--md', `icon-sport-${selectedTreeItem.id}`];
            break;
        case 'categoryId':
            item.name = _get(categories, [selectedTreeItem.id, 'name'], '');
            item.flag = getFlag(selectedTreeItems[0].id, selectedTreeItems[1].id);
            item.icon = '';
            break;
        case 'tournamentId':
            item.name = _get(tournaments, [selectedTreeItem.id, 'name'], '');
            item.flag = getFlag(selectedTreeItems[0].id, selectedTreeItems[1].id);
            item.icon = '';
            break;
        default:
            return item;
    }
    return item;
}

export function getLottoNavItem({
    isSystemFilter,
    featuredLottoGames,
    selectedTreeItems,
    selectedFeaturedItem,
}: {
    isSystemFilter: boolean,
    featuredLottoGames: Partial<LottoEvent>[],
    selectedTreeItems: INode[],
    selectedFeaturedItem: Partial<LottoEvent> | null,
}) {
    const item = {
        name: i18n.t('all'),
    } as NavItem;
    if (isSystemFilter) {
        return {
            name: i18n.t('system'),
        };
    }
    if (selectedFeaturedItem) {
        item.name = featuredLottoGames.find(({ id }) => selectedFeaturedItem === id)!.name!;
    } else {
        const selectedItem = selectedTreeItems[selectedTreeItems.length - 1];
        return selectedItem || item;
    }

    return item;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/mobile/helpers/navigation.ts